import { brand } from '@workday/canvas-tokens-web'

// `baseStyle` receives `props.theme`, so type is read from the active theme. `errorSmall`
// owns the error type AND color (legacy red flag-OFF, Canvas critical flag-ON), spread inline
// so it wins Chakra's FormErrorMessage default. The icon reuses `errorSmall`'s color rather
// than `icon.critical.default`, which is @deprecated in favour of the `brand.fg.critical.default`
// token `errorSmall` already carries.
export const FormError = {
  baseStyle: ({ theme }) => ({
    text: {
      ...theme.textStyles.errorSmall,
      mt: 2,
      display: 'flex',
      alignItems: 'flex-start',
      '& .chakra-form__error-message-text': {
        pt: 1
      }
    },
    icon: {
      color: theme.textStyles.errorSmall.color,
      mr: 1
    },
    warningText: {
      ...theme.textStyles.bodySmallSemi,
      mt: 2,
      display: 'flex',
      alignItems: 'flex-start',
      '& .chakra-form__warning-message-text': {
        pt: 1
      }
    },
    warningIcon: {
      // The dedicated `system.color.icon.caution.default` is deprecated (→ fg.contrast),
      // so the warning icon uses the same non-deprecated caution token as the warned field
      // border (brand.caution.400) instead.
      color: `var(${brand.common.caution.inner})`,
      mr: 1
    },
    warningMessage: {
      pl: 1
    }
  })
}
